import { Package } from "./package";

export interface Bundle {
  id: number;
  code: string;
  title: string;
  description: string;
  currency: string;
  src_region: string | null;
  dst_region: string | null;
  long_description: string;
  is_public: boolean;
  expiry: string;
  available_from: string;
  sku: number;
  version: number;
  created_at: string;
  updated_at: string;
  package_short_codes: string[];
  
  // dynamically added fields
  _oldCode?: string; // only for displaying updated bundle
  packages?: Package[];
  price?: number;
}

export interface BundleWithQTY {
  id: number;
  code: string;
  title: string;
  description: string;
  currency: string;
  src_region: string | null;
  dst_region: string | null;
  long_description: string;
  is_public: boolean;
  expiry: string;
  available_from: string;
  sku: number;
  version: number;
  created_at: string;
  updated_at: string;
  package_short_codes: string[];

  // dynamically added fields
  packages?: Package[];
  price?: number;
  qty?: number;
  discount_rate?: number;
  _score?:number; // sort find match score
}



function New(): Bundle {
  return {
    id: 0,
    code: '',
    title: '',
    description: '',
    currency: '',
    src_region: null,
    dst_region: null,
    long_description: '',
    is_public: true,
    expiry: '',
    available_from: '',
    sku: 0,
    version: 0,
    created_at: '',
    updated_at: '',
    package_short_codes: [],
  };
}

export default {
  // Format,
  New
};
